import { Image, ImageProps } from "@chakra-ui/react";

import MAP_ICON from "../icons/map_icon.svg";

const MapIcon = (props: ImageProps) => (
  <Image
    src={MAP_ICON}
    {...props}
  />
);
export default MapIcon;
